import {
  type GigproAdminRead,
  getSupportOpsGigproAdminsListQueryOptions,
  getSupportOpsPermissionsListQueryOptions,
  type ScopedAdminPermissionRead,
  type UserResponse,
} from "@sidegigllc/api/client";
import type { WarmableQuery } from "routing/warmQueries";
import { MANAGE_GIGPRO_ADMIN, MANAGE_PERMISSIONS, userHasCapability } from "../capabilities";
import type { Grantee, PermissionRoster } from "./api";

type QueriesInput = { user: UserResponse | undefined };

const groupByPermission = (reads: Array<ScopedAdminPermissionRead>): Array<PermissionRoster> => {
  const byPermission = new Map<string, Array<Grantee>>();
  for (const read of reads) {
    const grantees = byPermission.get(read.permission) ?? [];
    grantees.push({ user_id: read.user_id, name: read.user_name });
    byPermission.set(read.permission, grantees);
  }
  return Array.from(byPermission, ([permission, grantees]) => ({ permission, grantees }));
};

const toGrantees = (reads: Array<GigproAdminRead>): Array<Grantee> =>
  reads.map((read) => ({ user_id: read.user_id, name: read.user_name }));

export const permissionRosterQuery = ({ user }: QueriesInput) =>
  getSupportOpsPermissionsListQueryOptions({
    query: { enabled: userHasCapability(user, MANAGE_PERMISSIONS), select: groupByPermission },
  });

export const gigproAdminRosterQuery = ({ user }: QueriesInput) =>
  getSupportOpsGigproAdminsListQueryOptions({
    query: {
      enabled: (user?.is_gigpro_admin ?? false) && userHasCapability(user, MANAGE_GIGPRO_ADMIN),
      select: toGrantees,
    },
  });

export const queries = (input: QueriesInput): Array<WarmableQuery> => [
  permissionRosterQuery(input),
  gigproAdminRosterQuery(input),
];
